import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Checkbox from '@dc/ui-library/src/molecules/Checkbox/Checkbox';
import Rating from '@dc/ui-library/src/molecules/Rating/Rating';
import { toggleCheckboxOption } from '../../../../../appState/ducks/listingPageFilters';
import { filterTypes } from './filterHelpers';
import { filterOptionPropTypes } from './propTypes';


class CheckboxList extends PureComponent {
  onCheckboxCheck(checkboxData) {
    this.props.setSpinner(this.props.name);

    if (checkboxData.quantity === 0 && checkboxData.active === false) {
      return;
    }

    let shouldFetchNewData = true;
    if (this.props.mobileDevice) {
      // Desktop fetches immediately, mobile after clicking on apply button
      shouldFetchNewData = false;
    }

    this.props.toggleCheckboxOption(
      {
        filterName: this.props.name,
        filterType: this.props.type,
        checkboxData: checkboxData,
        fetchNewData: shouldFetchNewData
      }
    );
  }

  getRatingLabel(filterOption) {
    return (
      <Fragment>
        <Rating
          maxCount={this.props.maxValue / 2}
          ratingValue={parseInt(filterOption.value, 10)}
        />
        {parseInt(filterOption.value, 10) === this.props.maxValue
          ? `${filterOption.value / 2} `
          : `${filterOption.value / 2} or more `
        }
        {filterOption.quantity !== null &&
          <small>({filterOption.quantity})</small>
        }
      </Fragment>
    );
  }

  getImageLabel(filterOption) {
    const image = filterOption.images[0];
    return (
      <Fragment>
        <img
          src={image.url}
          alt={filterOption.label}
          className="dc-filter__image"
        />
        {` ${filterOption.label} `}
        {filterOption.quantity !== null &&
          <small>({filterOption.quantity})</small>
        }
      </Fragment>
    );
  }

  renderCheckboxLabel(filterOption) {
    if (this.props.type === filterTypes.rating) {
      return this.getRatingLabel(filterOption);
    }

    if (filterOption.images && filterOption.images.length > 0) {
      return this.getImageLabel(filterOption);
    }

    return (
      <Fragment>
        {` ${filterOption.label} `}
        {filterOption.quantity !== null &&
        <small>({filterOption.quantity})</small>
          }
      </Fragment>
    );
  }

  render() {
    return this.props.options.map(filter => (
      <li
        className="dc-filter__option"
        key={`${filter.label}${filter.value}`}
      >
        <Checkbox
          size={this.props.mobileDevice ? 'small' : 'extra-small'}
          label={this.renderCheckboxLabel(filter)}
          disabled={filter.quantity === 0 && filter.active === false}
          checked={filter.active}
          onCheck={() => this.onCheckboxCheck(filter)}
        />
      </li>
    ));
  }
}

CheckboxList.displayName = 'CheckboxList';

CheckboxList.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  maxValue: PropTypes.number,
  mobileDevice: PropTypes.bool.isRequired,
  options: PropTypes.arrayOf(filterOptionPropTypes).isRequired,
  toggleCheckboxOption: PropTypes.func,
  setSpinner: PropTypes.func
};

CheckboxList.defaultProps = {
  maxValue: null,
  setSpinner: () => {},
  toggleCheckboxOption: () => {}
};

export default connect(null, {
  toggleCheckboxOption
})(CheckboxList);
